var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = function SvgTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.473 11.001a2.917 2.917 0 0 1-5.774 0H.836v-10c0-.46.373-.833.833-.833h11.667c.46 0 .833.373.833.833v1.667h2.5l2.5 3.38V11h-1.696a2.917 2.917 0 0 1-5.774 0zm5.03-9.166h-10v6.708a2.917 2.917 0 0 1 4.72.791h4.727q.212-.443.553-.79zm1.666 5h3.334v-.238l-1.674-2.262h-1.66zm.417 5a1.25 1.25 0 1 0 0-2.501 1.25 1.25 0 0 0 0 2.5m-8.75-1.25a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
  })));
};
export default SvgTruck;